// extracted by mini-css-extract-plugin
export var primitiveLabel = "_v5-0";